<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_2" title="Photo"><br/></h2>
<div class="photo"><img alt="3769_IMG01.psd" class="photo" src="Images/3769_IMG01.jpg"/></div>
<p class="caption"><em>The Birmingham Good Friday march, on April 12, 1963, led by (from left) Fred Shuttlesworth, Ralph Abernathy and Martin Luther King Jr.</em></p>
<p class="caption"><em><span class="small-caps">(Used by permission of Birmingham, Alabama, Public Library Archives.)</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// photo.vue?b674fd5e